import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../componentes/Plantilla/Plantilla';
import styles from './LegalPages.module.css';

export const TerminosCondiciones = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className={styles.legalContainer}>
        <div className={styles.legalHeader}>
          <h1 className={styles.legalTitle}>Términos y Condiciones</h1>
          <div className={styles.lineaTitulo}></div>
        </div>

        <div className={styles.legalContent}>
          <p>
            Al acceder y utilizar el sitio web de <strong>Sistemas y Equipos Industriales y Medio Ambiente (SEIMA)</strong>, usted acepta estar sujeto a los siguientes Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, le rogamos no utilizar nuestra plataforma.
          </p>

          <h2>1. Uso de la Información</h2>
          <p>
            La información contenida en este sitio web (descripciones de equipos, características técnicas, capacidades, entre otros) tiene un propósito exclusivamente informativo y orientativo. SEIMA se esfuerza por mantener la información actualizada, pero no garantiza la exactitud absoluta, integridad o actualidad del material publicado. Las características de los equipos y catálogos pueden variar de acuerdo con los fabricantes (DOMUS, MAYTAG, etc.) sin previo aviso.
          </p>

          <h2>2. Relación Comercial</h2>
          <p>
            El envío de un formulario de contacto, solicitud de cotización o mensaje a través de este sitio web no constituye una relación comercial vinculante ni un contrato de prestación de servicios. Toda venta de equipos, instalación o servicio de mantenimiento requerirá una propuesta formal (cotización) por escrito, la cual deberá ser aprobada y firmada por ambas partes bajo sus propios términos comerciales específicos.
          </p>

          <h2>3. Propiedad Intelectual</h2>
          <p>
            Todo el contenido de este sitio web, incluyendo textos, gráficos, logotipos, imágenes, clips de video y software, es propiedad de SEIMA o de los fabricantes de los equipos que representamos, y está protegido por las leyes de propiedad intelectual internacionales y de la República de Guatemala. Queda estrictamente prohibida su reproducción, distribución o modificación sin autorización expresa por escrito de SEIMA.
          </p>

          <h2>4. Limitación de Responsabilidad</h2>
          <p>
            SEIMA no se hará responsable por daños directos, indirectos, incidentales o consecuentes que puedan derivarse del uso o la incapacidad de uso de este sitio web o de la información contenida en el mismo. La correcta selección y aplicación de los equipos industriales para fines específicos es responsabilidad del cliente, con la asesoría de nuestro equipo técnico durante la etapa de cotización formal.
          </p>

          <h2>5. Enlaces a Terceros</h2>
          <p>
            Nuestro sitio web puede contener enlaces a sitios web de terceros (como fabricantes o redes sociales). Estos sitios externos no están bajo el control de SEIMA, por lo que no somos responsables de su contenido, políticas de privacidad ni prácticas comerciales.
          </p>

          <h2>6. Ley Aplicable y Jurisdicción</h2>
          <p>
            Los presentes Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de la República de Guatemala. Cualquier controversia que surja en relación con este sitio web será sometida a la jurisdicción de los tribunales competentes en la Ciudad de Guatemala.
          </p>

          <p style={{ marginTop: '40px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.4)' }}>
            <strong>Última actualización:</strong> Junio de 2026.
          </p>
        </div>

        <div className={styles.legalFooter}>
          <Link to="/" className={styles.regresarBtn}>
            ← Regresar al Inicio
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default TerminosCondiciones;
